/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PaginationComponent} from './pagination.component';
import {NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {TooltipModule} from '../tooltip/tooltip.module';

@NgModule({
    declarations: [PaginationComponent],
    imports: [
        CommonModule,
        NgbPaginationModule,
        TooltipModule
    ],
    exports: [PaginationComponent]
})
export class PaginationModule {
}
